(ns superadmin.users.grants.add-grant-ocp
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.agency :as agency-queries]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [superadmin.roles.queries :as roles-queries]
            [superadmin.users.queries :as q]
            [uix.core :as uix :refer [$ defui]]))

(defui dropdown-wrapper [{:keys [options value on-change placeholder sx]}]
  (r/as-element
   [dropdown {:options options
              :value value
              :on-change on-change
              :placeholder placeholder
              :sx sx}]))

(defui add-grant-form [{:keys [form-data error agency-options
                               advertiser-options role-options
                               update-field]}]
  (let [selected-role (:role form-data)
        role-scope (-> selected-role :allowed-scopes first)]

    ($ Stack {:spacing 2}
       (when error
         ($ Alert {:severity "error" :sx #js {:mb 2}}
            error))

       ($ Stack {:spacing 2}
          ($ form-field
             {:label "Role"
              :required? true}
             ($ dropdown-wrapper {:options role-options
                                  :value (:role form-data)
                                  :on-change #(update-field :role %)
                                  :placeholder "Select role..."
                                  :sx #js {:minWidth "150px"}}))

          (when selected-role
            ($ Typography (str "Scope: " role-scope)))

          (when (or (= role-scope "agency") (= role-scope "advertiser"))
            ($ form-field
               {:label "Agency"
                :required? true}
               ($ dropdown-wrapper {:options agency-options
                                    :value (:agency-id form-data)
                                    :on-change #(update-field :agency-id %)
                                    :placeholder "Select agency..."
                                    :sx #js {:minWidth "150px"}})))
          (when (= role-scope "advertiser")
            ($ form-field
               {:label "Advertiser"
                :required? true}
               ($ dropdown-wrapper {:options advertiser-options
                                    :value (:advertiser-id form-data)
                                    :on-change #(update-field :advertiser-id %)
                                    :placeholder "Select advertiser..."
                                    :sx #js {:minWidth "150px"}})))))))

(defocp add-grant-ocp :superadmin/add-grant
  {:width "50%"}
  [props]
  (let [{:keys [user-id]} props
        [form-data set-form-data] (uix/use-state {:agency-id nil
                                                  :advertiser-id nil
                                                  :role-id nil})
        [error set-error] (uix/use-state nil)

        ;; Fetch agencies
        {agencies-data :data agencies-loading :isPending} (use-query (agency-queries/superadmin-agencies-query))
        agency-options (uix/use-memo
                        (fn []
                          (->> agencies-data
                               (map #(hash-map :label (:name %) :value (:id %)))
                               (sort-by :label)
                               vec))
                        [agencies-data])

        ;; Fetch advertisers for selected agency
        selected-agency-id (:agency-id form-data)
        {advertisers-data :data advertisers-loading :isPending}
        (use-query (q/agency-advertisers-query selected-agency-id))

        advertiser-options (uix/use-memo
                            (fn []
                              (->> advertisers-data
                                   (map #(hash-map :label (:name %) :value (:id %)))
                                   (sort-by :label)
                                   vec))
                            [advertisers-data])

        {roles-data :data roles-loading :isPending} (use-query (roles-queries/roles-query))
        role-options (map #(identity {:label (:name %) :value %})
                          roles-data)

        role-scope (-> form-data :role :allowed-scopes first)

        {create-grant :mutate submitting :isPending} (use-mutation (q/create-user-grant-mutation {:user-id user-id}))

        on-submit (uix/use-callback
                   (fn []
                     (set-error nil)
                     (let [scope-id (if (= role-scope "agency")
                                      (:agency-id form-data)
                                      (:advertiser-id form-data))
                           payload {:role-id (-> form-data :role :id)
                                    :scope-type role-scope
                                    :scope-id scope-id}]
                       (create-grant payload
                                     #js {:onSuccess (fn []
                                                       (set-form-data {:agency-id nil
                                                                       :scope-type "agency"
                                                                       :advertiser-id nil
                                                                       :role-id nil})
                                                       (rf/dispatch [:ocp/close]))
                                          :onError (fn [^js err]
                                                     (let [error-data (->clj (.-data err))]
                                                       (set-error (or (:message error-data)
                                                                      "Failed to create grant"))))})))
                   [form-data create-grant role-scope])

        update-field (uix/use-callback
                      (fn [field value]
                        (set-form-data (assoc form-data field value)))
                      [form-data])]

    ($ ocp
       {:title "Add Grant"}
       ($ Stack {:sx #js {:display "flex"
                          :flexDirection "column"
                          :height "100%"}}
          ($ Stack {:sx #js {:flexGrow 1}}
             ($ add-grant-form {:user-id user-id
                                :form-data form-data
                                :set-form-data set-form-data
                                :error error
                                :set-error set-error
                                :agency-options agency-options
                                :agencies-loading agencies-loading
                                :advertiser-options advertiser-options
                                :advertisers-loading advertisers-loading
                                :role-options role-options
                                :roles-loading roles-loading
                                :update-field update-field}))
          ($ Stack {:sx #js {:py 2}}
             ($ Button
                {:variant "contained"
                 :onClick on-submit
                 :disabled submitting}
                "Add Grant"))))))
